import React, {Fragment} from "react";
import {useTranslation} from "react-i18next";
import {useNotification} from "../ui/notification/NotificationProvider";
import {CsvExport} from "./CSVExport";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {Typography} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import DialogActions from "@material-ui/core/DialogActions";

interface CSVHelperProps {
    content: {
        headers: string[],
        examples: string[][]
    },
    open: boolean,
    renderAction: (actions: any) => any,
    handleClose: () => void,
}

const CSVHelper: React.FC<CSVHelperProps> = ({content, open, renderAction, handleClose}) => {
    const {t} = useTranslation();
    const {pushError} = useNotification();

    const contentHeadersTranslated = content.headers.map((h: string) => t(`_Common.Labels.${h}`));

    const displayHeaderRowDetails = (): string => {
        let toDisplay = '';
        for (let i = 0; i < contentHeadersTranslated.length - 1; i++) {
            toDisplay += contentHeadersTranslated[i] + ', ';
        }
        return toDisplay + contentHeadersTranslated[contentHeadersTranslated.length - 1];
    }

    const displayNextRowDetails = (): string => {
        let toDisplay = '';
        for (let i = 0; i < content.headers.length - 1; i++) {
            toDisplay += t(`_Shared.CSV.CSVFormat.Details.${content.headers[i]}`) + ', '
        }
        return toDisplay + t(`_Shared.CSV.CSVFormat.Details.${content.headers[content.headers.length - 1]}`);
    }

    const csvTemplateFilenameBuilder = () => {
        return `${t(`_Shared.CSV.Template.Filename`)}.csv`
    }

    const csvTemplateContentBuilder = () => {
        return {data: [], headers: contentHeadersTranslated};
    }


    const actions = <Fragment>
        <CsvExport
            contentBuilder={csvTemplateContentBuilder}
            filenameBuilder={csvTemplateFilenameBuilder}
            onError={(message: any) => pushError({message})}>
            {t('_Shared.CSV.Template.Download')}
        </CsvExport>
    </Fragment>;

    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title"
                maxWidth={'md'} open={open}>
            <DialogTitle id="customized-dialog-title">
                {t('_Shared.CSV.CSVFormat.Title')}
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    {t('_Shared.CSV.CSVFormat.Description')}
                </Typography>
                <Typography gutterBottom>
                    {t('_Shared.CSV.CSVFormat.Rules.HeaderRow') + displayHeaderRowDetails()}
                </Typography>
                <Typography gutterBottom>
                    {t('_Shared.CSV.CSVFormat.Rules.NextRow') + displayNextRowDetails()}
                </Typography>
                <Typography gutterBottom>
                    {t('_Shared.CSV.CSVFormat.Rules.Template')}
                </Typography>
                <Table>
                    <TableHead>
                        <TableRow>
                            {contentHeadersTranslated.map((header: any, id: any) => <TableCell
                                key={id}>{header}</TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {content.examples.map((example: any, id: any) => <TableRow key={id}>
                            {example.map((value: any, cellId: any) => <TableCell key={cellId}>{value}</TableCell>)}
                        </TableRow>)}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                {renderAction(actions)}
            </DialogActions>
        </Dialog>
    );
};
export default CSVHelper;
